import { apiRequest } from './httpClient';

export const getMetaAdsDashboard = (days = 30) => apiRequest('getMetaAdsDashboard', {
  method: 'GET', query: { days },
});

export const saveMetaAdsConnection = (payload) => apiRequest('saveMetaAdsConnection', {
  method: 'POST', body: payload,
});

export const syncMetaAdsInsights = (days = 30) => apiRequest('syncMetaAdsInsights', {
  method: 'POST', body: { days },
});

export const saveMetaAdsDraft = (payload) => apiRequest('saveMetaAdsDraft', {
  method: 'POST', body: payload,
});

export const generateMetaContentDraft = (payload) => apiRequest('generateMetaContentDraft', {
  method: 'POST', body: payload,
});

export const generateMetaCreativeImage = (payload) => apiRequest('generateMetaCreativeImage', {
  method: 'POST', body: payload,
});

export const createMetaVeoVideo = (payload) => apiRequest('createMetaVeoVideo', {
  method: 'POST', body: payload,
});

export const getMetaVeoVideoJob = (jobId) => apiRequest('getMetaVeoVideoJob', {
  method: 'GET', query: { jobId },
});

export const getMetaContentStudio = () => apiRequest('getMetaContentStudio', { method: 'GET' });

export const getMetaContentPublishStatus = (postId) => apiRequest('getMetaContentPublishStatus', {
  method: 'GET', query: { postId },
});

export const saveMetaContentDraft = (payload) => apiRequest('saveMetaContentDraft', {
  method: 'POST', body: payload,
});

export const publishMetaContent = (postId) => apiRequest('publishMetaContent', {
  method: 'POST', body: { postId },
});
export const scheduleMetaContent = ({ postId, scheduledAt, assignedTo = [] }) => apiRequest('scheduleMetaContent', {
  method: 'POST', body: { postId, scheduledAt, assignedTo },
});

export const archiveMetaContent = (postId, restore = false) => apiRequest('archiveMetaContent', {
  method: 'POST', body: { postId, restore },
});

export const deleteMetaContent = (postId) => apiRequest('deleteMetaContent', {
  method: 'POST', body: { postId },
});

export const archiveMetaVeoVideo = (videoId, restore = false) => apiRequest('archiveMetaVeoVideo', {
  method: 'POST', body: { videoId, restore },
});

export const deleteMetaVeoVideo = (videoId) => apiRequest('deleteMetaVeoVideo', {
  method: 'POST', body: { videoId },
});

export const generateMetaContentPlan = (payload) => apiRequest('generateMetaContentPlan', {
  method: 'POST', body: payload,
});
